<template>
  <ValidationProvider
    v-slot="{ errors }"
    :name="name"
    :rules="rules"
    :vid="vid">
    <BaseCheckboxGroup
      :label="label"
      :name="name"
      :value="value"
      :options="options"
      :errors="errors"
      v-on="$listeners" />
  </ValidationProvider>
</template>

<script>
import BaseCheckboxGroup from '@/components/parts/BaseCheckboxGroup.vue'
export default {
  components: {
    BaseCheckboxGroup
  },
  props: {
    value: {
      type: [String, Number, Array],
      default: null
    },
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    rules: {
      type: String,
      required: true
    },
    vid: {
      type: String,
      default: null
    },
    errors: {
      type: Array,
      default: () => []
    },
  }
}
</script>

<style>

</style>